import { render, staticRenderFns } from "./packs-statistics.vue?vue&type=template&id=4e1a00de"
import script from "./packs-statistics.vue?vue&type=script&lang=js"
export * from "./packs-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports